import axios from "axios";
//import store from "@/store";

const state = {
    authUser: {},
    isAuthenticated: false,
    isVerification: false,
    isTypeUser: false, // 0 - customer
    //userPermissions: [],
    currentPage: {},
}

const getters = {
    authUser(state) {
        return state.authUser;
    },
    isAuthenticated(state) {
        return state.isAuthenticated;
    },
    isVerification(state) {
        return state.isVerification;
    },
    isTypeUser(state) {
        return state.isTypeUser;
    },
    /*userPermissions(state) {
        return state.userPermissions;
    },*/
    currentPage(state) {
        return state.currentPage;
    },
}

const mutations = {
    authUser(state, payload) {
        if (payload.id) {
            state.authUser = payload
        }
    },
    isAuthenticated(state, payload) {
        state.isAuthenticated = payload
    },
    isVerification(state, payload) {
        state.isVerification = !!payload;
    },
    isTypeUser(state, payload) {
        state.isTypeUser = !!payload;
    },
    /*userPermissions(state, payload) {
        console.log('mutations - ',payload);
        if(payload.length>0){
            state.userPermissions = payload;
        }
    },*/
    currentPage(state, payload) {
        state.currentPage = payload;
    }
}

const computed = {}

const actions = {
    checkAuth(context) {
        const X_XSRF_TOKEN = !!localStorage.getItem('X-XSRF-TOKEN')
        context.commit('isAuthenticated', X_XSRF_TOKEN)
        try {
            if (X_XSRF_TOKEN) {
                axios.post('/api/user/info').then(r => {
                    if (r.status === 200) {
                        //context.commit('isVerification', r.data.data.verification)
                        //context.commit('isTypeUser', r.data.data.type)
                        context.commit('authUser', r.data)
                       /* context.commit('userPermissions', r.data.permissions)*/
                    }/*else{
                        context.commit('userPermissions', [])
                    }*/
                })
            }
        } catch (error) {
            throw new Error(error)
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
    computed
}
